export default __webpack_public_path__ + "static/media/react.35639ed9.png";